import type { Tenant } from "@saquei/types";

export class ApiError extends Error {
    constructor(public status: number, message: string) {
        super(message);
        this.name = "ApiError";
    }
}

async function jsonOrThrow<T>(resp: Response): Promise<T> {
    if (!resp.ok) {
        let msg = `HTTP ${resp.status}`;
        try {
            const body = await resp.json();
            if (body?.error?.message) msg = String(body.error.message);
        } catch {
            // ignore parse errors
        }
        throw new ApiError(resp.status, msg);
    }
    return (await resp.json()) as T;
}

export async function fetchMyTenant(): Promise<Tenant> {
    const resp = await fetch("/api/v1/me/tenant", {
        method: "GET",
        credentials: "include",
        headers: { Accept: "application/json" },
    });
    return jsonOrThrow<Tenant>(resp);
}
